{
  "generic": "Sorry an error has occurred, please try again. If you're still having issues, please contact our support team.",
  "forms": {
    "number": {
      "numeric": "Please enter a valid number",
      "min": "Must be {min} or more",
      "min_exclusive": "Must be more than {min}",
      "max": "Must be {max} or less",
      "integer": "Please enter a whole number"
    },
    "string": {
      "non_empty": "This field can't be empty",
      "min": "Must be at least {min} characters",
      "max": "Must be no more than {max} characters",
      "email": "Must be a valid email address"
    },
    "array": {
      "min": "Must select at least {min}",
      "max": "Must select no more than {max}"
    },
    "min_exceeds_max": "Maximum must be greater than minimum",
    "slug": "Use lowercase letters, numbers, and hyphens only",
    "slugStartingWithLetter": "Must start with a letter",
    "required": "This field is required",
    "duplicate_handle": "This handle is already in use"
  },
  "forbidden": "You don't have permission to perform this action.",
  "conflict": "This change conflicts with the current state. Please refresh and try again."
}
